<h1 mat-dialog-title>
  Clawback automated bonus
</h1>
<div mat-dialog-content>
  <span class="reward-summary">
    {{ rewardName }} - ${{ amount }}
  </span>
  <span class="info">
    This will remove the reward amount from the member allowance balance and reverse the reward in team history.
  </span>
  <form class="form" *ngIf="form" [formGroup]="form">
    <mat-form-field>
      <mat-label>Reason</mat-label>
      <textarea matInput rows="3" formControlName="reason"></textarea>
    </mat-form-field>
    <mat-checkbox formControlName="skipStripeRefund">
      Stripe refund was already handled
    </mat-checkbox>
    <mat-form-field *ngIf="form.get('skipStripeRefund')?.value">
      <mat-label>Stripe refund ID</mat-label>
      <input matInput formControlName="externalStripeRefundId">
    </mat-form-field>
  </form>
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button [disabled]="!form.valid" class="donebutton" color="primary" (click)="clawbackClicked()">Clawback</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
